import { HeartPulse } from 'lucide-react';
import { CardVariant, colorMap } from './constants';
import { ACCENT_HEIGHT_PX } from '@repo/ui/theme';

export interface StatCardProps {
  title: string;
  value: number | string;
  unit?: string;
  subtitle: string;
  variant: CardVariant;
  icon?: React.ReactNode;
}

export function StatCard({ title, value, unit, subtitle, variant, icon }: StatCardProps) {
  const colors = colorMap[variant];
  const defaultIcon = <HeartPulse className="h-6 w-6" />;

  return (
    <div className="relative flex h-full flex-col overflow-hidden rounded-lg border border-[var(--anl-border)] bg-[var(--anl-surface-elev)] p-5 shadow-sm">
      <div className="flex items-center justify-between">
        <div className="text-lg font-medium text-[var(--anl-text)]">{title}</div>
        <div className="rounded-full border border-[var(--anl-text)] p-2 text-[var(--anl-text)]">
          {icon || defaultIcon}
        </div>
      </div>
      <div className="mt-3 text-4xl font-bold text-[var(--anl-text)]">
        {value}
        {unit && <span className="text-sm text-[var(--anl-text-muted)]"> {unit}</span>}
      </div>
      <div className="mt-1 text-xs text-[var(--anl-text-muted)]">{subtitle}</div>
      <div
        className="absolute bottom-0 left-0 right-0"
        style={{ height: ACCENT_HEIGHT_PX, backgroundColor: colors.accent }}
      />
    </div>
  );
}
